
const KNOWN_KEYS = ["auth-storage", "useAuthStore", "auth"]; 

export function getAuthRoleFromStorage(): string | null {
  // 1. Try known keys first (fast path)
  for (const key of KNOWN_KEYS) {
    const raw = localStorage.getItem(key);
    if (!raw) continue;
    try {
      const parsed = JSON.parse(raw);
      const role = parsed?.state?.role;
      if (role) return String(role).toUpperCase();
    } catch {
    }
  }

  // 2. Fallback: scan all localStorage keys
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;
    const raw = localStorage.getItem(key);
    if (!raw) continue;
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.state?.role && parsed?.state?.isAuthenticated !== undefined) {
        return String(parsed.state.role).toUpperCase();
      }
    } catch {
      continue;
    }
  }

  return null;
}

export function isAdminRole(): boolean {
  const role = getAuthRoleFromStorage();
  return role === "ADMIN";
}

export function isManagerRole(): boolean {
  const role = getAuthRoleFromStorage();
  return role === "MANAGER";
}

export function isSuperAdminRole(): boolean {
  const role = getAuthRoleFromStorage();
  return role === "SUPER_ADMIN";
}